var dust = require('dustjs-linkedin');
(function(dust){dust.register("src-web-home-templates-appHome",body_0);function body_0(chk,ctx){return chk.w("<div id=\"cookie\" class=\"cookie\"></div><div id=\"loader\" class=\"hidden overlay-container showOverlay\"></div><div id=\"paywall\" class=\"hidden overlay-container showOverlay\"></div><div id=\"error\" class=\"hidden overlay-container showOverlay\"></div><div id=\"regionSelector\" class=\"hidden\"></div><div id=\"settings\" class=\"hidden overlay-container showOverlay\"></div><div id=\"app-container\" class=\"app-home\"><div class=\"top-bar-container\"></div><div id=\"app-content\"></div></div>");}body_0.__dustBody=!0;return body_0}(dust));
module.exports = 'src-web-home-templates-appHome';


//////////////////
// WEBPACK FOOTER
// ./src/web/home/templates/appHome.dust
// module id = 528
// module chunks = 1